import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B11PaymentTypeManagementPage } from '../b11-payment-type-management/b11-payment-type-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B11bPaymentTypeInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-b11b-payment-type-info',
	templateUrl: 'b11b-payment-type-info.html',
})
export class B11bPaymentTypeInfoPage {
	
	private todo : FormGroup;
	loading: any;
	Status: any;
	public errorMessage: any = "";
	
	paymentTypeData = { TYPE:'', AUTHORIZE:'NO', PAYMENT_TYPE_ACTIVE:'YES'}
	PAYMENT_TYPE_ID:any;
	
	constructor(public navCtrl: NavController, public navParams: NavParams,
				private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
				public loadingCtrl: LoadingController, public alertCtrl : AlertController) {
		
		this.todo = this.formBuilder.group({
			type: ['', Validators.required],
			authorize: ['', Validators.required],
			active: ['', Validators.required],
		});
		this.PAYMENT_TYPE_ID = this.navParams.get('paramID');
		
		let tbl = ["PAYMENT_TYPE"];
		let column = ["PAYMENT_TYPE_ID"];
		let value = [this.PAYMENT_TYPE_ID];
		
		let tblkey = ["No"];
		let fktbl = ["No"];
		let fkkey = ["No"];
  
		let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

		let mydata = Object.assign(jsonitem);
		let json_data = this.serviceapi.json_readdata(mydata,"1");
		this.showLoader();

		this.serviceapi.readdata(json_data,"PAYMENT_TYPE","1","1").then((result) => {
			
			this.Status = result["Message"];			
			if (this.Status == '1') {
				this.loading.dismiss();				
				let Records = result["Records"];
				this.paymentTypeData.TYPE = Records[0]["TYPE"];
				this.paymentTypeData.AUTHORIZE = Records[0]["AUTHORIZE"];
				this.paymentTypeData.PAYMENT_TYPE_ACTIVE = Records[0]["PAYMENT_TYPE_ACTIVE"];
				//console.log(this.paymentTypeData);
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad B11bPaymentTypeInfoPage');
	}
	
	deletePaymentType() {
		let confirm = this.alertCtrl.create({
			title: 'Confirmation',
			message: 'Are you sure you want to delete this payment type? This action cannot be undone.',
			buttons: [
				{
					text: 'No',
					handler: () => {
						//console.log('Disagree clicked');
					}
				},
				{
					text: 'Yes',
					handler: () => {
						//console.log('Agree clicked');
						this.showLoader();
						this.serviceapi.deletedata('PAYMENT_TYPE', 'PAYMENT_TYPE_ID', this.PAYMENT_TYPE_ID).then((result) => {
							this.Status = result["Message"];
							if (this.Status == "1") {
								this.loading.dismiss();
								this.navCtrl.setRoot(B11PaymentTypeManagementPage);
							}
							else {
								this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
								this.loading.dismiss();
							}
						}, (err) => {
							this.errorMessage = "Loading Error. Please try again.";
							this.loading.dismiss();
						});
					}
				}
			]
		});
		confirm.present();
	}
	
	updatePaymentType() {
		//console.log(this.paymentTypeData);
		this.serviceapi.updatedata('PAYMENT_TYPE', 'PAYMENT_TYPE_ID', this.PAYMENT_TYPE_ID, this.paymentTypeData).then((result) => {
			this.Status = result["Message"];
			if (this.Status == "1") {
				this.loading.dismiss();
				this.navCtrl.setRoot(B11PaymentTypeManagementPage);
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});
	}

	goToPaymentType() {
		this.navCtrl.pop();
	}

	goTo() {
		this.navCtrl.setRoot(B11PaymentTypeManagementPage);
	}

	showLoader() {
		this.loading = this.loadingCtrl.create({
			content: 'Loading...',
		});
		this.loading.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/b11b-payment-type-info/b11b-payment-type-info.ts